/* Copyright (C) 2022 ev-i Informationstechnologie GmbH */

export enum ResetPasswordResult {
    SUCCESS = "SUCCESS",
    WRONG_PASSWORD = "WRONG_PASSWORD",
    INVALID_PASSWORD = "INVALID_PASSWORD",
}

export default ResetPasswordResult;
